<template>
<div
        v-show="isMobile === false"
        class="other_head"
        style="padding-right: 20px"
    >
        <div class="tip_text">{{ tipText }}</div>
        <EditHeadLogoutPopup v-if="!isInToca"> </EditHeadLogoutPopup>
    </div>
</template>

<script lang="ts">
import { clearCookieAndToLogin } from '../../login';

import EditHeadLogoutPopup from '../kbedit/EditHeadLogoutPopup.vue';
import { mapState } from 'vuex';
import { getBrowser } from '../../utils/browser';

export default {
    name: 'other_head',
    components: {
        EditHeadLogoutPopup
    },
    props: {
        tipText: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            showLogoutPopup: false
        };
    },
    computed: {
        ...mapState({
            userDetail: (state: any) => state.userModule.userDetail
        }),
        memberName() {
            return this.userDetail?.memberName ?? 'N';
        },
        memberAvatar() {
            const str = this.userDetail?.memberAvatar as string;
            if (str == null || str === 'undefined') return undefined;
            return JSON.parse(str)['100'];
        },
        isInToca() {
            return getBrowser().isInTocaApp;
        },
        isMobile() {
            return getBrowser().isMobile;
        }
    },
    methods: {
        onLogoutClick() {
            clearCookieAndToLogin(true);
        }
    }
};
</script>

<style lang="scss" scoped>
.other_head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 54px;

    height: 54px;
    background: #ffffff;
    box-shadow: inset 0 -1px 0 0 #e2e6ed;

    .tip_text {
        margin-left: 16px;
        height: 20px;
        line-height: 20px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 14px;
        color: #121317;
        letter-spacing: 0;
    }

    .img_avatar {
        margin-right: 16px;
    }
}
</style>
